import cx from 'clsx';

import styles from './style.module.scss';

import type { ReactNode } from 'react';

export const Block = ({
  children,
  title,
  className,
}: {
  title: string;
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div className={cx(styles['container'])}>
      <div className={styles['title']}>{title}</div>
      <div className={className}>{children}</div>
    </div>
  );
};
